export default __webpack_public_path__ + "static/media/erv.17027249.svg";